/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const HandYesNoIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M9.5,6.974 C9.5,6.155 10.172,5.491 10.992,5.491 C11.82,5.491 12.5,6.162 12.5,6.991 L12.5,12.991 L16.947,14.491 C17.935,14.808 18.154,15.993 17.921,17.007 L16.895,22.522 L8.91,22.522 L4.894,16.507 C4.44,15.811 4.439,14.498 5.439,14.498 C6.439,14.498 7.5,14.909 9.5,17.991 L9.5,6.974 Z" />
      <polyline points="7.5 1.305 2.479 8.305 0.5 6.327" />
      <path d="M15.5,1.305 L22.5,8.305" />
      <path d="M22.5,1.305 L15.5,8.305" />
    </g>
  </svg>
);

export default HandYesNoIcon;
